import { render } from "./SliderButton.vue?vue&type=template&id=410a5086&scoped=true"
import script from "./SliderButton.vue?vue&type=script&lang=js"
export * from "./SliderButton.vue?vue&type=script&lang=js"

import "./SliderButton.vue?vue&type=style&index=0&id=410a5086&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-410a5086"]])

export default __exports__